export const activeResultOwnerByOrderId = new Map();
export const pendingResultOwnerQueue = [];
export const handledResultEventKeys = new Set();

export function rememberResultOwner(panelId, orderId) {
  const normalizedOrderId = String(orderId || "").trim();
  if (!panelId || !normalizedOrderId) {
    return;
  }

  activeResultOwnerByOrderId.set(normalizedOrderId, panelId);
  if (
    !pendingResultOwnerQueue.some(
      (entry) => entry.orderId === normalizedOrderId,
    )
  ) {
    pendingResultOwnerQueue.push({ panelId, orderId: normalizedOrderId });
  }
}

export function forgetResultOwner(orderId) {
  const normalizedOrderId = String(orderId || "").trim();
  if (!normalizedOrderId) {
    return;
  }

  activeResultOwnerByOrderId.delete(normalizedOrderId);
  const queueIndex = pendingResultOwnerQueue.findIndex(
    (entry) => entry.orderId === normalizedOrderId,
  );
  if (queueIndex >= 0) {
    pendingResultOwnerQueue.splice(queueIndex, 1);
  }
}

export function readResultOrderIds(tradeResult) {
  const result = tradeResult?.result;
  return [
    result?.id,
    result?.order_id,
    result?.orderId,
    result?.trade_id,
    result?.tradeId,
    result?.clientOrderId,
    result?.client_order_id,
    tradeResult?.id,
    tradeResult?.order_id,
    tradeResult?.orderId,
    tradeResult?.trade_id,
    tradeResult?.tradeId,
    tradeResult?.clientOrderId,
    tradeResult?.client_order_id,
  ]
    .map((value) => String(value || "").trim())
    .filter(Boolean);
}

export function createResultEventKey(tradeResult, resultOrderIds) {
  if (resultOrderIds.length > 0) {
    return `ids:${resultOrderIds.join("|")}`;
  }

  const result = tradeResult?.result || {};
  return [
    "fallback",
    result?.side,
    result?.entryPrice,
    result?.exitPrice,
    result?.amount,
    result?.profit,
    result?.status,
    result?.result,
    tradeResult?.settledAt,
    tradeResult?.createdAt,
  ]
    .map((value) => String(value ?? ""))
    .join("|");
}

export function claimFallbackResultOwner(eventKey) {
  if (!eventKey || handledResultEventKeys.has(eventKey)) {
    return null;
  }

  const nextOwner = pendingResultOwnerQueue.shift();
  if (!nextOwner) {
    return null;
  }

  activeResultOwnerByOrderId.delete(nextOwner.orderId);
  handledResultEventKeys.add(eventKey);
  setTimeout(() => {
    handledResultEventKeys.delete(eventKey);
  }, 45000);
  return nextOwner.panelId;
}

export function markResultEventHandled(eventKey) {
  if (!eventKey) {
    return;
  }

  handledResultEventKeys.add(eventKey);
  setTimeout(() => {
    handledResultEventKeys.delete(eventKey);
  }, 45000);
}

export function normalizeTradeResultStatus(status) {
  const normalized = String(status || "")
    .trim()
    .toLowerCase();
  if (["won", "win", "winner", "success"].includes(normalized)) {
    return "won";
  }
  if (["lost", "loss", "lose", "loser", "failed"].includes(normalized)) {
    return "lost";
  }
  if (["draw", "tie", "refund", "refunded"].includes(normalized)) {
    return "draw";
  }
  return normalized || "lost";
}

